/*!
 *
 * lightbox.js
 *
 */

var scrollPos;

function lightBoxClose (e){
	e.preventDefault();
	$('.sw-Lightbox-visible').removeClass('sw-Lightbox-visible');
	$('body').css({
		position: 'static',
		top: 0
	});
	window.scrollTo(0, scrollPos);
};


$.fn.lightbox = function(){
	return this.each(function(){
		var target = $(this).attr('href');
		$(target).addClass('sw-Lightbox-init');

		$(this).on('click', function(e){
			e.preventDefault();
			var _target = $(this).attr('href');
			scrollPos = $(window).scrollTop();
			$('body').css({
				position: 'fixed',
				top: -scrollPos
			});
			$(_target).addClass('sw-Lightbox-visible');
		})
	});
};

(function(){
	var $inner = $('.sw-Lightbox_Inner');
	var $close = $('.sw-Lightbox_Close')
	$inner.on('click', lightBoxClose);
	$close.on('click', lightBoxClose);
}());


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/lightbox.js
// module id = 25
// module chunks = 0